/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/familyBreachesMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a FamilyBreaches. */
export class FamilyBreaches {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a FamilyBreaches.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Start dark web scanning on behalf of the Member (csid). If fullScan is set true all found new
   * breaches are return by the API.Else response is filtered based on the provided breach entity
   * value and breach type except for SSN where filtering is only applied on SSN type.
   * @summary Start dark web scanning for the Member (csid)
   * @param csid
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyBreachesScanAndGetBreachesResponse>
   */
  scanAndGetBreaches(csid: string, options?: Models.FamilyBreachesScanAndGetBreachesOptionalParams): Promise<Models.FamilyBreachesScanAndGetBreachesResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  scanAndGetBreaches(csid: string, callback: coreHttp.ServiceCallback<Models.BreachedDetail[]>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  scanAndGetBreaches(csid: string, options: Models.FamilyBreachesScanAndGetBreachesOptionalParams, callback: coreHttp.ServiceCallback<Models.BreachedDetail[]>): void;
  scanAndGetBreaches(csid: string, options?: Models.FamilyBreachesScanAndGetBreachesOptionalParams | coreHttp.ServiceCallback<Models.BreachedDetail[]>, callback?: coreHttp.ServiceCallback<Models.BreachedDetail[]>): Promise<Models.FamilyBreachesScanAndGetBreachesResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      scanAndGetBreachesOperationSpec,
      callback) as Promise<Models.FamilyBreachesScanAndGetBreachesResponse>;
  }

  /**
   * Update the state of composite or single breach entity state given breach id, entityId and the
   * type of data field
   * @summary Update the state of breach entity or data field
   * @param breachId
   * @param csid
   * @param entityId
   * @param [options] The optional parameters
   * @deprecated This operation is deprecated. Please do not use it any longer.
   * @returns Promise<Models.FamilyBreachesUpdateBreachEntityStateResponse>
   */
  updateBreachEntityState(breachId: string, csid: string, entityId: string, options?: Models.FamilyBreachesUpdateBreachEntityStateOptionalParams): Promise<Models.FamilyBreachesUpdateBreachEntityStateResponse>;
  /**
   * @param breachId
   * @param csid
   * @param entityId
   * @param callback The callback
   * @deprecated This operation is deprecated. Please do not use it any longer.
   */
  updateBreachEntityState(breachId: string, csid: string, entityId: string, callback: coreHttp.ServiceCallback<Models.IdentityMonitoringBreach>): void;
  /**
   * @param breachId
   * @param csid
   * @param entityId
   * @param options The optional parameters
   * @param callback The callback
   * @deprecated This operation is deprecated. Please do not use it any longer.
   */
  updateBreachEntityState(breachId: string, csid: string, entityId: string, options: Models.FamilyBreachesUpdateBreachEntityStateOptionalParams, callback: coreHttp.ServiceCallback<Models.IdentityMonitoringBreach>): void;
  updateBreachEntityState(breachId: string, csid: string, entityId: string, options?: Models.FamilyBreachesUpdateBreachEntityStateOptionalParams | coreHttp.ServiceCallback<Models.IdentityMonitoringBreach>, callback?: coreHttp.ServiceCallback<Models.IdentityMonitoringBreach>): Promise<Models.FamilyBreachesUpdateBreachEntityStateResponse> {
    return this.client.sendOperationRequest(
      {
        breachId,
        csid,
        entityId,
        options
      },
      updateBreachEntityStateOperationSpec,
      callback) as Promise<Models.FamilyBreachesUpdateBreachEntityStateResponse>;
  }

  /**
   * Update in batch the state of multiple breach entities or data fields using the given breach Id
   * and a list entityId.
   * @summary Batch update the state of breach entities or data fields.
   * @param breachId
   * @param csid
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyBreachesBatchUpdateBreachEntityStateResponse>
   */
  batchUpdateBreachEntityState(breachId: string, csid: string, options?: Models.FamilyBreachesBatchUpdateBreachEntityStateOptionalParams): Promise<Models.FamilyBreachesBatchUpdateBreachEntityStateResponse>;
  /**
   * @param breachId
   * @param csid
   * @param callback The callback
   */
  batchUpdateBreachEntityState(breachId: string, csid: string, callback: coreHttp.ServiceCallback<Models.BreachedDetailWithoutValues>): void;
  /**
   * @param breachId
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  batchUpdateBreachEntityState(breachId: string, csid: string, options: Models.FamilyBreachesBatchUpdateBreachEntityStateOptionalParams, callback: coreHttp.ServiceCallback<Models.BreachedDetailWithoutValues>): void;
  batchUpdateBreachEntityState(breachId: string, csid: string, options?: Models.FamilyBreachesBatchUpdateBreachEntityStateOptionalParams | coreHttp.ServiceCallback<Models.BreachedDetailWithoutValues>, callback?: coreHttp.ServiceCallback<Models.BreachedDetailWithoutValues>): Promise<Models.FamilyBreachesBatchUpdateBreachEntityStateResponse> {
    return this.client.sendOperationRequest(
      {
        breachId,
        csid,
        options
      },
      batchUpdateBreachEntityStateOperationSpec,
      callback) as Promise<Models.FamilyBreachesBatchUpdateBreachEntityStateResponse>;
  }

  /**
   * Currently supports only updating state to New/Remediated, which updates the states of the
   * underlying entities to remediated or new based on the request.
   * @summary Batch patch breaches
   * @param csid
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyBreachesPatchBreachesResponse>
   */
  patchBreaches(csid: string, options?: Models.FamilyBreachesPatchBreachesOptionalParams): Promise<Models.FamilyBreachesPatchBreachesResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  patchBreaches(csid: string, callback: coreHttp.ServiceCallback<Models.BreachedDetailWithoutValues[]>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  patchBreaches(csid: string, options: Models.FamilyBreachesPatchBreachesOptionalParams, callback: coreHttp.ServiceCallback<Models.BreachedDetailWithoutValues[]>): void;
  patchBreaches(csid: string, options?: Models.FamilyBreachesPatchBreachesOptionalParams | coreHttp.ServiceCallback<Models.BreachedDetailWithoutValues[]>, callback?: coreHttp.ServiceCallback<Models.BreachedDetailWithoutValues[]>): Promise<Models.FamilyBreachesPatchBreachesResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      patchBreachesOperationSpec,
      callback) as Promise<Models.FamilyBreachesPatchBreachesResponse>;
  }

  /**
   * Get all existing breaches for the Member (csid)
   * @summary Get all breaches for the Member (csid)
   * @param csid
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyBreachesGetBreachesResponse>
   */
  getBreaches(csid: string, options?: coreHttp.RequestOptionsBase): Promise<Models.FamilyBreachesGetBreachesResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  getBreaches(csid: string, callback: coreHttp.ServiceCallback<Models.BreachedDetail[]>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  getBreaches(csid: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.BreachedDetail[]>): void;
  getBreaches(csid: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.BreachedDetail[]>, callback?: coreHttp.ServiceCallback<Models.BreachedDetail[]>): Promise<Models.FamilyBreachesGetBreachesResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      getBreachesOperationSpec,
      callback) as Promise<Models.FamilyBreachesGetBreachesResponse>;
  }

  /**
   * Get the specified breach for the Member (csid) through the provided breachId.
   * @summary Get the specified breach for the Member (csid)
   * @param breachId
   * @param csid
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyBreachesGetBreachByIdResponse>
   */
  getBreachById(breachId: string, csid: string, options?: coreHttp.RequestOptionsBase): Promise<Models.FamilyBreachesGetBreachByIdResponse>;
  /**
   * @param breachId
   * @param csid
   * @param callback The callback
   */
  getBreachById(breachId: string, csid: string, callback: coreHttp.ServiceCallback<Models.BreachedDetail>): void;
  /**
   * @param breachId
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  getBreachById(breachId: string, csid: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.BreachedDetail>): void;
  getBreachById(breachId: string, csid: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.BreachedDetail>, callback?: coreHttp.ServiceCallback<Models.BreachedDetail>): Promise<Models.FamilyBreachesGetBreachByIdResponse> {
    return this.client.sendOperationRequest(
      {
        breachId,
        csid,
        options
      },
      getBreachByIdOperationSpec,
      callback) as Promise<Models.FamilyBreachesGetBreachByIdResponse>;
  }

  /**
   * Mark a recommendation as completed by setting the isCompleted flag of the recommendation to
   * true.
   * @summary Complete a recommendation.
   * @param breachId
   * @param csid
   * @param entityId
   * @param recommendationId Possible values include: 'EnableMFA', 'ChangeSharedPasswords',
   * 'ContactRestorationServices', 'ChangePassword', 'CheckUnfamiliarTransactionsBank',
   * 'CheckUnfamiliarTransactionsCreditCard', 'CheckUnfamiliarTransactionsEbay',
   * 'CheckUnfamiliarClaims', 'ChangeSecurityQuestionsMothersName', 'SelectNewPinBank',
   * 'RequestNewCard', 'RequestNewCardRetailCard', 'SelectNewPinCreditCard',
   * 'ChangeSecurityQuestionsBirthday', 'ReviewCreditReports', 'ReportStolenNationalId',
   * 'ReportStolenPassport', 'CheckUnfamiliarTransactionsPayPal',
   * 'CheckUnfamiliarTransactionsRetail', 'ReportIdTheft', 'PlaceCreditFreeze',
   * 'UpdateAutomaticPayments', 'ContactPhoneProvider', 'DotNotCall', 'EnableMFABank',
   * 'EnableMFABankPassword', 'EnableMFAEbay', 'EnableMFAPaypal',
   * 'ReviewCreditReportsAndContactRestorationServices', 'ChangePasswordAndUsePasswordManager',
   * 'ChangeSharedPasswordsWithExplanation'
   * @param [options] The optional parameters
   * @deprecated This operation is deprecated. Please do not use it any longer.
   * @returns Promise<Models.FamilyBreachesCompleteRecommendationResponse>
   */
  completeRecommendation(breachId: string, csid: string, entityId: string, recommendationId: Models.RecommendationId, options?: Models.FamilyBreachesCompleteRecommendationOptionalParams): Promise<Models.FamilyBreachesCompleteRecommendationResponse>;
  /**
   * @param breachId
   * @param csid
   * @param entityId
   * @param recommendationId Possible values include: 'EnableMFA', 'ChangeSharedPasswords',
   * 'ContactRestorationServices', 'ChangePassword', 'CheckUnfamiliarTransactionsBank',
   * 'CheckUnfamiliarTransactionsCreditCard', 'CheckUnfamiliarTransactionsEbay',
   * 'CheckUnfamiliarClaims', 'ChangeSecurityQuestionsMothersName', 'SelectNewPinBank',
   * 'RequestNewCard', 'RequestNewCardRetailCard', 'SelectNewPinCreditCard',
   * 'ChangeSecurityQuestionsBirthday', 'ReviewCreditReports', 'ReportStolenNationalId',
   * 'ReportStolenPassport', 'CheckUnfamiliarTransactionsPayPal',
   * 'CheckUnfamiliarTransactionsRetail', 'ReportIdTheft', 'PlaceCreditFreeze',
   * 'UpdateAutomaticPayments', 'ContactPhoneProvider', 'DotNotCall', 'EnableMFABank',
   * 'EnableMFABankPassword', 'EnableMFAEbay', 'EnableMFAPaypal',
   * 'ReviewCreditReportsAndContactRestorationServices', 'ChangePasswordAndUsePasswordManager',
   * 'ChangeSharedPasswordsWithExplanation'
   * @param callback The callback
   * @deprecated This operation is deprecated. Please do not use it any longer.
   */
  completeRecommendation(breachId: string, csid: string, entityId: string, recommendationId: Models.RecommendationId, callback: coreHttp.ServiceCallback<Models.IdentityMonitoringRecommendation>): void;
  /**
   * @param breachId
   * @param csid
   * @param entityId
   * @param recommendationId Possible values include: 'EnableMFA', 'ChangeSharedPasswords',
   * 'ContactRestorationServices', 'ChangePassword', 'CheckUnfamiliarTransactionsBank',
   * 'CheckUnfamiliarTransactionsCreditCard', 'CheckUnfamiliarTransactionsEbay',
   * 'CheckUnfamiliarClaims', 'ChangeSecurityQuestionsMothersName', 'SelectNewPinBank',
   * 'RequestNewCard', 'RequestNewCardRetailCard', 'SelectNewPinCreditCard',
   * 'ChangeSecurityQuestionsBirthday', 'ReviewCreditReports', 'ReportStolenNationalId',
   * 'ReportStolenPassport', 'CheckUnfamiliarTransactionsPayPal',
   * 'CheckUnfamiliarTransactionsRetail', 'ReportIdTheft', 'PlaceCreditFreeze',
   * 'UpdateAutomaticPayments', 'ContactPhoneProvider', 'DotNotCall', 'EnableMFABank',
   * 'EnableMFABankPassword', 'EnableMFAEbay', 'EnableMFAPaypal',
   * 'ReviewCreditReportsAndContactRestorationServices', 'ChangePasswordAndUsePasswordManager',
   * 'ChangeSharedPasswordsWithExplanation'
   * @param options The optional parameters
   * @param callback The callback
   * @deprecated This operation is deprecated. Please do not use it any longer.
   */
  completeRecommendation(breachId: string, csid: string, entityId: string, recommendationId: Models.RecommendationId, options: Models.FamilyBreachesCompleteRecommendationOptionalParams, callback: coreHttp.ServiceCallback<Models.IdentityMonitoringRecommendation>): void;
  completeRecommendation(breachId: string, csid: string, entityId: string, recommendationId: Models.RecommendationId, options?: Models.FamilyBreachesCompleteRecommendationOptionalParams | coreHttp.ServiceCallback<Models.IdentityMonitoringRecommendation>, callback?: coreHttp.ServiceCallback<Models.IdentityMonitoringRecommendation>): Promise<Models.FamilyBreachesCompleteRecommendationResponse> {
    return this.client.sendOperationRequest(
      {
        breachId,
        csid,
        entityId,
        recommendationId,
        options
      },
      completeRecommendationOperationSpec,
      callback) as Promise<Models.FamilyBreachesCompleteRecommendationResponse>;
  }

  /**
   * Mark recommendation(s) as in/complete by setting {isCompleted} of the recommendations.
   * @summary Update states of recommendations of {recommendationId} in breach.
   * @param csid
   * @param breachId
   * @param recommendationId Possible values include: 'EnableMFA', 'ChangeSharedPasswords',
   * 'ContactRestorationServices', 'ChangePassword', 'CheckUnfamiliarTransactionsBank',
   * 'CheckUnfamiliarTransactionsCreditCard', 'CheckUnfamiliarTransactionsEbay',
   * 'CheckUnfamiliarClaims', 'ChangeSecurityQuestionsMothersName', 'SelectNewPinBank',
   * 'RequestNewCard', 'RequestNewCardRetailCard', 'SelectNewPinCreditCard',
   * 'ChangeSecurityQuestionsBirthday', 'ReviewCreditReports', 'ReportStolenNationalId',
   * 'ReportStolenPassport', 'CheckUnfamiliarTransactionsPayPal',
   * 'CheckUnfamiliarTransactionsRetail', 'ReportIdTheft', 'PlaceCreditFreeze',
   * 'UpdateAutomaticPayments', 'ContactPhoneProvider', 'DotNotCall', 'EnableMFABank',
   * 'EnableMFABankPassword', 'EnableMFAEbay', 'EnableMFAPaypal',
   * 'ReviewCreditReportsAndContactRestorationServices', 'ChangePasswordAndUsePasswordManager',
   * 'ChangeSharedPasswordsWithExplanation'
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyBreachesCompleteBreachRecommendationResponse>
   */
  completeBreachRecommendation(csid: string, breachId: string, recommendationId: Models.RecommendationId, options?: Models.FamilyBreachesCompleteBreachRecommendationOptionalParams): Promise<Models.FamilyBreachesCompleteBreachRecommendationResponse>;
  /**
   * @param csid
   * @param breachId
   * @param recommendationId Possible values include: 'EnableMFA', 'ChangeSharedPasswords',
   * 'ContactRestorationServices', 'ChangePassword', 'CheckUnfamiliarTransactionsBank',
   * 'CheckUnfamiliarTransactionsCreditCard', 'CheckUnfamiliarTransactionsEbay',
   * 'CheckUnfamiliarClaims', 'ChangeSecurityQuestionsMothersName', 'SelectNewPinBank',
   * 'RequestNewCard', 'RequestNewCardRetailCard', 'SelectNewPinCreditCard',
   * 'ChangeSecurityQuestionsBirthday', 'ReviewCreditReports', 'ReportStolenNationalId',
   * 'ReportStolenPassport', 'CheckUnfamiliarTransactionsPayPal',
   * 'CheckUnfamiliarTransactionsRetail', 'ReportIdTheft', 'PlaceCreditFreeze',
   * 'UpdateAutomaticPayments', 'ContactPhoneProvider', 'DotNotCall', 'EnableMFABank',
   * 'EnableMFABankPassword', 'EnableMFAEbay', 'EnableMFAPaypal',
   * 'ReviewCreditReportsAndContactRestorationServices', 'ChangePasswordAndUsePasswordManager',
   * 'ChangeSharedPasswordsWithExplanation'
   * @param callback The callback
   */
  completeBreachRecommendation(csid: string, breachId: string, recommendationId: Models.RecommendationId, callback: coreHttp.ServiceCallback<Models.BreachRecommendation>): void;
  /**
   * @param csid
   * @param breachId
   * @param recommendationId Possible values include: 'EnableMFA', 'ChangeSharedPasswords',
   * 'ContactRestorationServices', 'ChangePassword', 'CheckUnfamiliarTransactionsBank',
   * 'CheckUnfamiliarTransactionsCreditCard', 'CheckUnfamiliarTransactionsEbay',
   * 'CheckUnfamiliarClaims', 'ChangeSecurityQuestionsMothersName', 'SelectNewPinBank',
   * 'RequestNewCard', 'RequestNewCardRetailCard', 'SelectNewPinCreditCard',
   * 'ChangeSecurityQuestionsBirthday', 'ReviewCreditReports', 'ReportStolenNationalId',
   * 'ReportStolenPassport', 'CheckUnfamiliarTransactionsPayPal',
   * 'CheckUnfamiliarTransactionsRetail', 'ReportIdTheft', 'PlaceCreditFreeze',
   * 'UpdateAutomaticPayments', 'ContactPhoneProvider', 'DotNotCall', 'EnableMFABank',
   * 'EnableMFABankPassword', 'EnableMFAEbay', 'EnableMFAPaypal',
   * 'ReviewCreditReportsAndContactRestorationServices', 'ChangePasswordAndUsePasswordManager',
   * 'ChangeSharedPasswordsWithExplanation'
   * @param options The optional parameters
   * @param callback The callback
   */
  completeBreachRecommendation(csid: string, breachId: string, recommendationId: Models.RecommendationId, options: Models.FamilyBreachesCompleteBreachRecommendationOptionalParams, callback: coreHttp.ServiceCallback<Models.BreachRecommendation>): void;
  completeBreachRecommendation(csid: string, breachId: string, recommendationId: Models.RecommendationId, options?: Models.FamilyBreachesCompleteBreachRecommendationOptionalParams | coreHttp.ServiceCallback<Models.BreachRecommendation>, callback?: coreHttp.ServiceCallback<Models.BreachRecommendation>): Promise<Models.FamilyBreachesCompleteBreachRecommendationResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        breachId,
        recommendationId,
        options
      },
      completeBreachRecommendationOperationSpec,
      callback) as Promise<Models.FamilyBreachesCompleteBreachRecommendationResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const scanAndGetBreachesOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/FamilyBreaches/scan",
  urlParameters: [
    Parameters.csid
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.ScanRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BreachedDetail"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const updateBreachEntityStateOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/FamilyBreaches/{breachId}/{entityId}",
  urlParameters: [
    Parameters.breachId,
    Parameters.csid,
    Parameters.entityId
  ],
  queryParameters: [
    Parameters.breachedType,
    Parameters.state
  ],
  responses: {
    200: {
      bodyMapper: Mappers.IdentityMonitoringBreach
    },
    404: {
      bodyMapper: Mappers.IdentityMonitoringBreach
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const batchUpdateBreachEntityStateOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/FamilyBreaches/{breachId}/entities",
  urlParameters: [
    Parameters.breachId,
    Parameters.csid
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.UpdateDatafieldBatchRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.BreachedDetailWithoutValues
    },
    404: {
      bodyMapper: Mappers.BreachedDetailWithoutValues
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const patchBreachesOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/FamilyBreaches",
  urlParameters: [
    Parameters.csid
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.PatchBreachesRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BreachedDetailWithoutValues"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getBreachesOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/FamilyBreaches",
  urlParameters: [
    Parameters.csid
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BreachedDetail"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getBreachByIdOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/FamilyBreaches/{breachId}",
  urlParameters: [
    Parameters.breachId,
    Parameters.csid
  ],
  responses: {
    200: {
      bodyMapper: Mappers.BreachedDetail
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const completeRecommendationOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/FamilyBreaches/{breachId}/{entityId}/{recommendationId}",
  urlParameters: [
    Parameters.breachId,
    Parameters.csid,
    Parameters.entityId,
    Parameters.recommendationId0
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.ResolveRecommendationRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.IdentityMonitoringRecommendation
    },
    404: {
      bodyMapper: Mappers.IdentityMonitoringRecommendation
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const completeBreachRecommendationOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/FamilyBreaches/{breachId}/recommendation/{recommendationId}",
  urlParameters: [
    Parameters.csid,
    Parameters.breachId,
    Parameters.recommendationId0
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.ResolveRecommendationRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.BreachRecommendation
    },
    404: {
      bodyMapper: Mappers.BreachRecommendation
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
